// src/pages/tickets/TicketDetallePage.tsx
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Tabs, TabsContent, TabsList, TabsTrigger, PageLoader } from '@/components/ui';
import { useTicket } from '@/hooks/queries/useTickets';
import {
  TicketHeader,
  TicketInfo,
  TicketComentarios,
  TicketAdjuntos,
  TicketHistorial,
  TicketAcciones,
  TicketFormModal,
} from './components';
import { CollabChatter } from '@/components/collab/CollabChatter';

export function TicketDetallePage() {
  const { id } = useParams<{ id: string }>();
  const { data: ticket, isLoading } = useTicket(id);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  if (isLoading) return <PageLoader message="Cargando ticket..." />;
  if (!ticket) {
    return (
      <div className="flex items-center justify-center h-96">
        <p className="text-gray-500">Ticket no encontrado</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <TicketHeader ticket={ticket} onEdit={() => setIsEditModalOpen(true)} />

      <div className="grid grid-cols-3 gap-6">
        {/* Contenido principal */}
        <div className="col-span-2">
          <Tabs defaultValue="comentarios">
            <TabsList>
              <TabsTrigger value="comentarios">
                Comentarios ({ticket.comentarios_count ?? 0})
              </TabsTrigger>
              <TabsTrigger value="adjuntos">Adjuntos ({ticket.adjuntos_count ?? 0})</TabsTrigger>
              <TabsTrigger value="historial">Historial</TabsTrigger>
              <TabsTrigger value="colaboracion">Colaboracion</TabsTrigger>
            </TabsList>

            <TabsContent value="comentarios" className="mt-4">
              <TicketComentarios ticketId={id!} />
            </TabsContent>

            <TabsContent value="adjuntos" className="mt-4">
              <TicketAdjuntos ticketId={id!} />
            </TabsContent>

            <TabsContent value="historial" className="mt-4">
              <TicketHistorial ticketId={id!} />
            </TabsContent>

            <TabsContent value="colaboracion" className="mt-4">
              <CollabChatter
                entityType="qops:ticket"
                entityId={`TKT-${ticket.numero}`}
                height="500px"
              />
            </TabsContent>
          </Tabs>
        </div>

        {/* Panel lateral */}
        <div className="space-y-4">
          <TicketInfo ticket={ticket} />
          <TicketAcciones ticket={ticket} />
        </div>
      </div>

      <TicketFormModal
        open={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
        ticket={ticket}
      />
    </div>
  );
}
